/**
 * Centralized Role-Based User ID Configuration (Frontend)
 *
 * Mirrors backend/src/config/roles.config.ts for frontend use.
 * Update IDs here when migrating between workspaces.
 *
 * Usage:
 *   import { ROLES, isAdmin } from 'config/roles.config'
 *
 *   if (isAdmin(currentUser.slackUserId)) { ... }
 */

export const ROLES = {
  /** Platform administrators */
  ADMIN_IDS: ['U0AE0JUASAX', 'U0AH4P65EDC'],

  /** Primary system admin (Colin) */
  SYSTEM_ADMIN: 'U0AE0JUASAX',

  /** Business owner / President (Justin) */
  BUSINESS_OWNER: 'U0AH4P65EDC',

  /** Accounting Coordinator (Ansley) */
  ACCOUNTING_COORDINATOR: 'U0ALSLREF3J',

  /** Accounting Manager (Jamie) */
  ACCOUNTING_MANAGER: 'U0AGRCHM6BH',

  /** Business Ops Manager (Phillip) */
  BUSINESS_OPS_MANAGER: 'U0AKZF2Q17C',

  /** COO (Nate) */
  COO: 'U0AE0JUASAX',

  /** Director of IT (An) */
  DIRECTOR_IT: 'U0AH4P65EDC',

  /** Bot user ID */
  BOT: 'U074L1BHWGM',
}

/** Deal types that trigger accounting coordinator notifications */
export const ACCOUNTING_COORDINATOR_DEAL_TYPES = ['CSA', 'MSA', 'MSA - Housing', 'IO']

/** Deal types that trigger accounting manager notifications */
export const ACCOUNTING_MANAGER_DEAL_TYPES = ['IO', 'RMSA', 'RCSA', 'RMSA - Housing']

/** Check if a user ID is an admin */
export const isAdmin = (userId: string): boolean => {
  return ROLES.ADMIN_IDS.includes(userId)
}

/** Check if a user ID is the system admin */
export const isSystemAdmin = (userId: string): boolean => {
  return userId === ROLES.SYSTEM_ADMIN
}
